module.exports = __webpack_public_path__ + "static/media/chemical.5cfe3728.jpg";